import './splash-loader.css';
import SplashLoaderTpl from './splash-loader.html';

class SplashLoaderController {
	/** @ngInject */
	constructor($timeout) {
		this.$timeout = $timeout;
		this.fadeSplash = false;
		this.showSplash = true;
		this._fadeTimer = null;
		this._hideTimer = null;
	}

	$onInit() {}

	$onDestroy() {
		this.$timeout.cancel(this._fadeTimer);
		this.$timeout.cancel(this._hideTimer);
	}

	$onChanges(changesObj) {
		if (changesObj.hideSplash.currentValue === false) {
			this.initHiding();
		}
	}

	initHiding() {
		this._fadeTimer = this.$timeout(() => {
			this.doFadeSplash();
		}, 1000);
	}

	doFadeSplash() {
		this.fadeSplash = true;
		this._hideTimer = this.$timeout(() => {
			this.showSplash = false;
		}, 2000);
	}
}

const SplashLoader = {
	template: SplashLoaderTpl,
	controller: SplashLoaderController,
	bindings: {
		hideSplash: '<',
	},
};

export default SplashLoader;
